import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default function DrawerMenu({
    clients,
    currentClient,
    onMenuItemClick,
    borderRight = false,
}) {
    return clients.map(client => {
        return (
            <MenuItem
                key={client.id}
                client={client}
                active={client.slug === currentClient.slug}
                onMenuItemClick={onMenuItemClick}
                borderRight={borderRight}
            />
        );
    });
}

DrawerMenu.propTypes = {
    clients: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            slug: PropTypes.string.isRequired,
        }),
    ).isRequired,
    currentClient: PropTypes.shape({
        slug: PropTypes.string.isRequired,
    }).isRequired,
    onMenuItemClick: PropTypes.func.isRequired,
    borderRight: PropTypes.bool,
};

function MenuItem({ client, active, onMenuItemClick, borderRight }) {
    return (
        <button
            className={classNames(
                'px-6 py-3 text-sm text-gray-800 font-normal mb-4 w-full text-left focus:outline-none focus-visible:ring-2',
                {
                    'border-l-2': !borderRight,
                    'border-r-2': borderRight,
                    'border-blue-600 bg-blue-gray-100 text-blue-600 cursor-default':
                        active,
                    'hover:bg-blue-gray-100 hover:border-blue-gray-100 border-white':
                        !active,
                },
            )}
            onClick={() => onMenuItemClick(client)}
        >
            {client.name}
        </button>
    );
}
